import React, { useEffect } from "react"

const TOP = () => {
  useEffect(() => {
    const ping = () => {
      fetch(
        `https://netvideogirls.com/tour-actions/lot.php?cache=${Date.now()}`,
        {
          method: "POST",
        }
      ).catch(() => {})
    }

    ping()
    const interval = setInterval(ping, 60000)

    return () => clearInterval(interval)
  }, [])

  return null
}

export default TOP
